import { useState } from "react";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Introduction from "./components/introduction/Introduction";
import Skills from "./components/Skills/Skills";
import WorkExperience from "./components/WorkExperience/WorkExperience";
import Projects from "./components/Projects/Projects";
import ContactMe from "./components/ContactMe/ContactMe";
import Pie from "./components/Footer/Pie";

function App() {
  const [isDark, setIsDark] = useState(true);

  const toggleTheme = () => {
    setIsDark((prev) => !prev);
  };

  return (
    <div className="App" data-theme={isDark ? "dark" : "light"}>
      <Navbar isDark={isDark} toggleTheme={toggleTheme} />
      <div className="contenedor">
        <Introduction />
        <Skills />
        <WorkExperience />
        <Projects />
        <ContactMe />
      </div>
      <Pie />
    </div>
  );
}

export default App;
